import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import state from '../store/wgw';

export default createReducer(state, {
  SET_MATERIAL_LIST: (state, { data }) => Immutable({ ...state, materialList: data }),
});
